import { gql } from "graphql-request";

// The photos behind a click on the web's ADMIN-ONLY "Public photos" overlay.
// Admin-only on the server (Queries::AdminPublicPhotos), which also re-checks
// that each photo is still public: ids that aren't are simply left out.
export const GetAdminPublicPhotos = gql`
  query GetAdminPublicPhotos($ids: [ID!]!) {
    adminPublicPhotos(ids: $ids) {
      id
      mediumUrl
      hdUrl
      capturedAt
      createdAt
      platform
      appVersion
      latitude
      longitude
      elevation
      adminUrl
      parent {
        type
        id
        name
        publicUrl
        adminUrl
      }
      uploader {
        id
        name
        adminUrl
      }
    }
  }
`;
